'use client'

import { Charts } from './Charts';
import FamilyAllowanceChartsDataProvider from './contexts/FamilyAllowanceChartContext';
const FamilyAllowanceWrapper = () => {
    return (
        <FamilyAllowanceChartsDataProvider>
            <Charts />
        </FamilyAllowanceChartsDataProvider>
    );
};

export default FamilyAllowanceWrapper;
